import React from 'react';
import { styled } from '@linaria/react';

const Container = styled.div<CheckboxListProps>`
  display: block;
  margin: ${props => typeof props.margin === 'number' ? `${props.margin}px` : props.margin};
`

export interface CheckboxListProps {
  children?: React.ReactNode;
  margin: string | number;
}

function CheckboxList({ children, margin }: CheckboxListProps) {
  return <Container margin={margin}>
    {children}
  </Container>;
};

CheckboxList.defaultProps = {
  margin: "0 0 30px"
}

export default CheckboxList;
